import { render, staticRenderFns } from "./AppThumbnail.vue?vue&type=template&id=8572986e&scoped=true&"
import script from "./AppThumbnail.vue?vue&type=script&lang=js&"
export * from "./AppThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./AppThumbnail.vue?vue&type=style&index=0&id=8572986e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8572986e",
  null
  
)

export default component.exports